'use strict';

var moduleName = 'filter-item-smart-bar';

module.exports = function () {
	$('.jsFilterItemSmartBar').each(function () {
		if($.data(this, moduleName + '-init')) return;
		$.data(this, moduleName + '-init', true);



		var $smartBar 	 = $(this),
			$form = $smartBar.closest('form');

		$form.on('change rangechange', function (event) {
			$smartBar.addClass('filter-item-smart-bar_load');
			var $input = $(event.target);
			showSmartBar($input);
		});

		function showSmartBar($input) {
			var barOffset = getSmartBarOffset($input, $form);

			$smartBar.css('top', barOffset);
			$smartBar.fadeIn(300);
		}

		function getSmartBarOffset($input, $form) {
			var target = $input.closest('label');

			if(!target.length) target = $input;

			return target.offset().top + target.outerHeight() / 2 - $form.offset().top;
		}



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/filterItemSmartBarInit.js
 **/